import { useAuth } from 'modules/auth/hooks/useAuth';
import { useRedirectForPartners } from 'hooks/useRedirectForPartners';

import { PrivateChains } from './components/PrivateChains';
import { PublicChains } from './components/PublicChains';
import { useChainViewSelector } from './components/ChainViewSelector';

export const ChainsListPage = () => {
  const { isLoggedIn } = useAuth();

  useRedirectForPartners();

  const { chainsViewTabs, selectedChainsViewTab } = useChainViewSelector();

  const Chains = isLoggedIn ? PrivateChains : PublicChains;

  return (
    <Chains
      chainsViewTabs={chainsViewTabs}
      selectedChainsViewTab={selectedChainsViewTab}
    />
  );
};
